import {
  Component,
  HostListener,
  Injector,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { ExtranetAuthenticationService } from '@src/app/core/services/extranet-authentication.service';
import { ExtranetMenuService } from '@src/app/core/services/extranet-menu.service';
import { GlobalJobSchedulerService } from '@src/app/core/services/global-job-scheduler.service';
import { HeaderService } from '@src/app/core/services/header.service';
import { PushNotificationService } from '@src/app/core/services/push-notification.service';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  AppConfig,
  AuthenticationService,
  BaseComponent,
  Configuration,
  StorageService
} from 'sigv-library';

@Component({
  selector: 'app-extranet-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [GlobalJobSchedulerService],
})
export class LayoutComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  isMenuVisible$ = this.menuService.getSideMenuObservable();
  isHeaderVisible$ = this.headerService.getHeaderObservable();
  breadcrumb$ = this.breadcrumbService.getBreadcrumbsObservable();

  private killTrigger: Subject<void> = new Subject();
  private refreshTokenTimer$ = timer(1800000, 1800000).pipe(
    takeUntil(this.killTrigger)
  );

  private timeoutID?: any;
  isPushEnabled: boolean = true;

  get envConfig(): any {
    return AppConfig.envConfig;
  }

  constructor(
    protected injector: Injector,
    private menuService: ExtranetMenuService,
    private authenticationService: AuthenticationService,
    private headerService: HeaderService,
    private extranetAuthenticationService: ExtranetAuthenticationService,
    private router: Router,
    private configuration: Configuration,
    private storageService: StorageService,
    private pushNotificationService: PushNotificationService
  ) {
    super(injector);
    this.isPushEnabled = this.envConfig.isPushEnabled;
  }

  ngOnInit(): void {
    this.idleLogOut();
    if (environment.isExtranet) {//&& this.appConfig.getAzureAD().enabled
      this.logger.info('Extranet login and enable azure ad');
      this.refreshTokenTimer$.subscribe({
        next: () => {
          //this.authenticationService.refreshToken();
          this.extranetAuthenticationService.refreshIdToken().subscribe({
            next: ()=>{},
            error: (err) => {},
          });
        },
        error: (err) => {
          this.logger.error('Layout Component - refreshToken', err);
        },
      });
    }

    // 當瀏覽器不同分頁登入或登出時，重整頁面
    window.addEventListener(
      'storage',
      (event) => {
        const isUserNoSame =
          this.authenticationService.currentUserValue?.userNo ===
          this.storageService.local.getItem(
            this.storageService.keys.UserProfile
          )?.userNo;

        if (event.storageArea === localStorage) {
          if (
            this.authenticationService.isAuthenticated === false ||
            !isUserNoSame
          ) {
            window.location.reload();
          }
        }
      },
      false
    );

    // 推播視窗
    if(this.isPushEnabled) {
      this.pushNotificationService.enablePushNotifications();
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
    this.killTrigger.next();
    this.killTrigger.complete();
  }

  @HostListener('mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  idleLogOut(): void {
    if (environment.isExtranet) {
      this.clearTimeout();
      this.timeoutID = setTimeout(() => {
        this.router.navigate(['/logout']);
      }, 1200000);
    }
  }

  clearTimeout(): void {
    if (this.timeoutID !== undefined) {
      clearTimeout(this.timeoutID);
    }
  }
}
